import { render, staticRenderFns } from "./NsImage.vue?vue&type=template&id=9a7e4ab0&scoped=true&"
import script from "./NsImage.vue?vue&type=script&lang=js&"
export * from "./NsImage.vue?vue&type=script&lang=js&"
import style0 from "./NsImage.vue?vue&type=style&index=0&id=9a7e4ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7e4ab0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a7e4ab0')) {
      api.createRecord('9a7e4ab0', component.options)
    } else {
      api.reload('9a7e4ab0', component.options)
    }
    module.hot.accept("./NsImage.vue?vue&type=template&id=9a7e4ab0&scoped=true&", function () {
      api.rerender('9a7e4ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsImage.vue"
export default component.exports